var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 178525"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 35.4,
    height: 35.4,
    rx: 3.7,
    fill: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 35.4,
    height: 35.4,
    rx: 3.7,
    stroke: "#CECECE",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.25 12C14.25 11.8011 14.329 11.6103 14.4697 11.4697C14.6103 11.329 14.8011 11.25 15 11.25H26.25C26.4489 11.25 26.6397 11.329 26.7803 11.4697C26.921 11.6103 27 11.8011 27 12C27 12.1989 26.921 12.3897 26.7803 12.5303C26.6397 12.671 26.4489 12.75 26.25 12.75H15C14.8011 12.75 14.6103 12.671 14.4697 12.5303C14.329 12.3897 14.25 12.1989 14.25 12ZM26.25 17.25H15C14.8011 17.25 14.6103 17.329 14.4697 17.4697C14.329 17.6103 14.25 17.8011 14.25 18C14.25 18.1989 14.329 18.3897 14.4697 18.5303C14.6103 18.671 14.8011 18.75 15 18.75H26.25C26.4489 18.75 26.6397 18.671 26.7803 18.5303C26.921 18.3897 27 18.1989 27 18C27 17.8011 26.921 17.6103 26.7803 17.4697C26.6397 17.329 26.4489 17.25 26.25 17.25ZM26.25 23.25H15C14.8011 23.25 14.6103 23.329 14.4697 23.4697C14.329 23.6103 14.25 23.8011 14.25 24C14.25 24.1989 14.329 24.3897 14.4697 24.5303C14.6103 24.671 14.8011 24.75 15 24.75H26.25C26.4489 24.75 26.6397 24.671 26.7803 24.5303C26.921 24.3897 27 24.1989 27 24C27 23.8011 26.921 23.6103 26.7803 23.4697C26.6397 23.329 26.4489 23.25 26.25 23.25ZM11.25 11.25H9.75C9.55109 11.25 9.36032 11.329 9.21967 11.4697C9.07902 11.6103 9 11.8011 9 12C9 12.1989 9.07902 12.3897 9.21967 12.5303C9.36032 12.671 9.55109 12.75 9.75 12.75H11.25C11.4489 12.75 11.6397 12.671 11.7803 12.5303C11.921 12.3897 12 12.1989 12 12C12 11.8011 11.921 11.6103 11.7803 11.4697C11.6397 11.329 11.4489 11.25 11.25 11.25ZM11.25 17.25H9.75C9.55109 17.25 9.36032 17.329 9.21967 17.4697C9.07902 17.6103 9 17.8011 9 18C9 18.1989 9.07902 18.3897 9.21967 18.5303C9.36032 18.671 9.55109 18.75 9.75 18.75H11.25C11.4489 18.75 11.6397 18.671 11.7803 18.5303C11.921 18.3897 12 18.1989 12 18C12 17.8011 11.921 17.6103 11.7803 17.4697C11.6397 17.329 11.4489 17.25 11.25 17.25ZM11.25 23.25H9.75C9.55109 23.25 9.36032 23.329 9.21967 23.4697C9.07902 23.6103 9 23.8011 9 24C9 24.1989 9.07902 24.3897 9.21967 24.5303C9.36032 24.671 9.55109 24.75 9.75 24.75H11.25C11.4489 24.75 11.6397 24.671 11.7803 24.5303C11.921 24.3897 12 24.1989 12 24C12 23.8011 11.921 23.6103 11.7803 23.4697C11.6397 23.329 11.4489 23.25 11.25 23.25Z",
    fill: "#646666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.fcf6e659.svg";
export { ForwardRef as ReactComponent };